import React, { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem('mr_cart');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem('mr_cart', JSON.stringify(cart));
  }, [cart]);

  // Add `qty` cartons of item to cart. If item already in cart, increases by qty.
  const add = (item, qty = 1) => {
    const addQty = Math.max(1, parseInt(qty, 10) || 1);
    setCart((prev) => {
      const ex = prev.find((c) => c.id === item.id);
      if (ex) return prev.map((c) => (c.id === item.id ? { ...c, qty: c.qty + addQty } : c));
      return [...prev, { ...item, qty: addQty }];
    });
  };

  // Increment/decrement quantity by `delta`.
  const updateQty = (id, delta) => {
    setCart((prev) =>
      prev
        .map((c) => (c.id === id ? { ...c, qty: c.qty + delta } : c))
        .filter((c) => c.qty > 0)
    );
  };

  // Set exact quantity for an item (used for bulk numeric input). qty < 1 removes the item.
  const setQty = (id, qty) => {
    const n = parseInt(qty, 10);
    if (!Number.isFinite(n) || n < 1) {
      setCart((prev) => prev.filter((c) => c.id !== id));
      return;
    }
    setCart((prev) => prev.map((c) => (c.id === id ? { ...c, qty: n } : c)));
  };

  const remove = (id) => setCart((prev) => prev.filter((c) => c.id !== id));
  const clear = () => setCart([]);

  const total = cart.reduce((s, c) => s + c.price * c.qty, 0);
  const count = cart.reduce((s, c) => s + c.qty, 0);

  return (
    <CartContext.Provider value={{ cart, add, updateQty, setQty, remove, clear, total, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
